import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import { getHolidayById } from 'RestAPIs/admin';

import { showSnackbar } from 'components/shared';

const useGetRowData = (rowId?: number) => {
  const { t } = useTranslation();
  const { data, isFetching } = useQuery({
    queryKey: ['holidays', 'get', rowId],
    queryFn: async () => {
      const { data } = await getHolidayById(rowId);
      return data;
    },
    enabled: !!rowId,
    onError: () => {
      showSnackbar({
        severity: 'error',
        message: t('holidays.errors.errorDuringFetching')
      });
    }
  });

  return { isFetching, data };
};

export default useGetRowData;
